import { BackendHttpService } from "./backendHttpService";

export interface SyncDisplayNameResult {
    firstName: string | null;
    lastName: string | null;
}

export class UserService extends BackendHttpService {
    constructor() {
        super("User");
    }

    async syncDisplayName(): Promise<SyncDisplayNameResult | null> {
        return this.post<object, SyncDisplayNameResult>({}, "sync-display-name");
    }
}
